export default __webpack_public_path__ + "static/media/CRYSTALLINE_9x16_MASTER_220625-2.7e85117e.mp4";